import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function FAQPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqCategories = [
    {
      category: '产品功能',
      icon: 'ri-function-line',
      questions: [
        {
          question: '智研云主要解决什么问题？',
          answer: '智研云是一款专业的研发费用管理系统，主要解决企业在研发费用管理中遇到的项目管理混乱、工时记录不准确、资料归档困难、合规风险高等问题。通过智能化、自动化的方式，帮助企业提升管理效率，降低合规风险。'
        },
        {
          question: '系统支持哪些类型的研发项目？',
          answer: '系统支持所有类型的研发项目，包括软件开发、硬件研发、工艺改进、技术创新等。无论是高新技术企业认定项目、加计扣除项目，还是普通研发项目，都可以在系统中进行管理。'
        },
        {
          question: '可以生成哪些报表？',
          answer: '系统可以生成多种专业报表，包括：会计核算报表、高新技术企业认定申报表、研发费用加计扣除申报表、IPO审计资料、项目成本分析报表、工时统计报表等。所有报表都符合相关政策要求，可以直接用于申报。'
        },
        {
          question: '系统如何保证数据安全？',
          answer: '我们采用银行级的数据加密技术，所有数据传输使用SSL加密。数据存储在阿里云、华为云等国内顶级云服务商的服务器上，支持多地备份。同时，系统具有完善的权限管理机制，确保数据只能被授权人员访问。'
        }
      ]
    },
    {
      category: '使用问题',
      icon: 'ri-question-line',
      questions: [
        {
          question: '系统需要安装吗？',
          answer: '不需要安装，智研云是基于云端的SaaS系统，只需要通过浏览器访问即可使用。同时我们也提供了移动端APP，支持iOS和Android系统，可以随时随地进行工时填报和数据查看。'
        },
        {
          question: '需要培训吗？',
          answer: '系统界面简洁直观，大部分功能无需培训即可上手。对于企业版客户，我们提供免费的现场培训服务。同时，我们还提供详细的操作手册、视频教程和在线客服支持，确保您能够快速掌握系统使用。'
        },
        {
          question: '可以导入历史数据吗？',
          answer: '可以的。系统支持Excel、CSV等格式的数据导入，我们的技术团队会协助您完成历史数据的迁移工作。对于数据量较大的企业，我们还可以提供定制化的数据迁移服务。'
        },
        {
          question: '支持与其他系统对接吗？',
          answer: '支持。系统提供标准的API接口，可以与ERP、财务系统、OA系统等进行对接。企业版客户还可以申请定制化的系统集成服务，实现数据的无缝流转。'
        }
      ]
    },
    {
      category: '价格与服务',
      icon: 'ri-price-tag-3-line',
      questions: [
        {
          question: '如何选择合适的版本？',
          answer: '基础版适合研发人员在20人以内的初创企业；专业版适合研发人员在100人以内的成长型企业，是性价比最高的选择；企业版适合大型企业和集团客户，提供更多高级功能和定制化服务。您可以先试用专业版，再根据实际需求选择。'
        },
        {
          question: '可以按月付费吗？',
          answer: '可以的。我们同时支持按月付费和按年付费两种方式。按年付费可以享受相当于10个月的价格，相当于优惠2个月。建议您选择按年付费，更加划算。'
        },
        {
          question: '提供哪些技术支持？',
          answer: '基础版提供邮件技术支持，专业版提供在线客服支持（工作日9:00-18:00），企业版提供专属客户经理和7×24小时技术支持。所有版本都可以访问我们的帮助中心和视频教程。'
        },
        {
          question: '可以申请发票吗？',
          answer: '可以的。我们支持开具增值税普通发票和增值税专用发票。在购买时填写发票信息，我们会在3个工作日内开具并邮寄给您。电子发票可以即时获取。'
        }
      ]
    },
    {
      category: '合规与政策',
      icon: 'ri-shield-check-line',
      questions: [
        {
          question: '系统生成的报表符合政策要求吗？',
          answer: '完全符合。我们的产品团队包括多名资深税务专家和会计师，系统内置的报表模板都严格按照最新的政策要求设计。每当政策更新时，我们会第一时间更新系统，确保报表始终符合要求。'
        },
        {
          question: '如何确保研发费用加计扣除的合规性？',
          answer: '系统内置了数十项合规检查规则，会自动检测研发活动是否符合加计扣除政策要求，包括项目立项、人员资质、费用归集、资料留存等各个环节。一旦发现风险，系统会及时预警并提供整改建议。'
        },
        {
          question: '系统如何帮助企业通过高新认定？',
          answer: '系统从项目管理、人员管理、费用归集、资料归档等多个维度，全面支持高新技术企业认定工作。系统可以自动生成认定所需的各类材料，确保研发费用占比、研发人员占比等关键指标符合要求，大大提高认定通过率。'
        },
        {
          question: '遇到税务稽查怎么办？',
          answer: '系统完整记录了研发活动的全过程，所有资料都有据可查。在遇到税务稽查时，可以快速导出所需的各类证明材料。企业版客户还可以获得我们合作的税务师事务所提供的专业咨询服务。'
        }
      ]
    }
  ];

  // Build FAQ schema
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqCategories.flatMap(category =>
      category.questions.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    )
  };

  useSEO({
    title: '常见问题 - 智研云 | FAQ | 使用帮助',
    description: '智研云常见问题解答，包括系统功能、使用方法、价格方案、技术支持等方面的问题。如有其他疑问，欢迎联系我们的客服团队。',
    keywords: '常见问题,FAQ,使用帮助,问题解答,技术支持',
    canonical: '/faq',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '智研云适合什么规模的企业使用？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '智研云提供基础版、专业版和企业版三种方案，适合小型、中型和大型企业使用。无论您的企业规模如何，我们都能提供合适的解决方案。'
          }
        },
        {
          '@type': 'Question',
          name: '系统支持哪些研发费用归集方式？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '系统支持多种数据归集方式，包括手工录入、Excel导入、API对接等，可以自动从财务系统、人事系统等获取数据，实现智能归集。'
          }
        },
        {
          '@type': 'Question',
          name: '如何保证数据的安全性？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们采用银行级加密技术，数据传输使用SSL加密，存储采用多重备份机制。同时提供完善的权限管理体系，确保数据安全可靠。'
          }
        },
        {
          '@type': 'Question',
          name: '是否提供免费试用？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，我们提供免费试用服务。您可以点击"免费试用"按钮注册账号，体验系统的完整功能。'
          }
        },
        {
          '@type': 'Question',
          name: '系统是否支持定制开发？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '企业版支持定制开发服务，我们可以根据您的具体需求进行功能定制和系统集成。详情请联系我们的销售团队。'
          }
        },
        {
          '@type': 'Question',
          name: '如何获得技术支持？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们提供7×24小时在线客服支持，您可以通过在线聊天、电话、邮件等方式联系我们。专业版和企业版还提供专属客户经理服务。'
          }
        }
      ]
    }
  });

  return (
    <>
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-emerald-50 via-teal-50 to-white py-24 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=FAQ%20and%20help%20center%20concept%20with%20question%20marks%20and%20information%20symbols%20in%20soft%20emerald%20and%20teal%20gradient%20modern%20friendly%20design&width=1920&height=600&seq=faq-hero-bg&orientation=landscape')] opacity-5 bg-cover bg-center"></div>
          
          <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-5 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-questionnaire-line"></i>
                <span>帮助中心</span>
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">常见问题</span>解答
              </h1>
              
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                这里汇总了用户最关心的问题和详细解答<br />
                如果没有找到您需要的答案，欢迎联系我们的客服团队
              </p>

              {/* Search Box */}
              <div className="max-w-2xl mx-auto">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索您想了解的问题..."
                    className="w-full px-6 py-4 pr-14 rounded-full border-2 border-gray-200 focus:border-emerald-500 focus:outline-none text-lg"
                  />
                  <button className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-full hover:from-emerald-700 hover:to-teal-700 transition-all cursor-pointer">
                    <i className="ri-search-line text-xl"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Categories */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            {faqCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-16 last:mb-0">
                <div className="flex items-center gap-4 mb-8">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl">
                    <i className={`${category.icon} text-2xl text-white`}></i>
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900">{category.category}</h2>
                </div>

                <div className="space-y-4">
                  {category.questions.map((faq, index) => {
                    const globalIndex = categoryIndex * 100 + index;
                    const isOpen = openIndex === globalIndex;

                    return (
                      <div
                        key={index}
                        className="bg-white rounded-2xl border-2 border-gray-100 hover:border-emerald-200 transition-all overflow-hidden"
                      >
                        <button
                          onClick={() => setOpenIndex(isOpen ? null : globalIndex)}
                          className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-emerald-50/50 transition-colors"
                        >
                          <div className="flex items-start gap-4 flex-1">
                            <i className={`ri-question-line text-emerald-600 text-2xl mt-1 flex-shrink-0`}></i>
                            <span className="text-lg font-semibold text-gray-900 pr-4">
                              {faq.question}
                            </span>
                          </div>
                          <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line text-2xl text-gray-400 flex-shrink-0 transition-transform`}></i>
                        </button>

                        {isOpen && (
                          <div className="px-8 pb-6 pl-20">
                            <p className="text-gray-600 leading-relaxed">
                              {faq.answer}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Support */}
        {/* Removed contact support section */}

      </main>
      <Footer />
    </>
  );
}
